/* tslint:disable */
/* eslint-disable */
/**
 * Organization service API
 * Service for Organizations management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeiTestStatus
 */
export interface LeiTestStatus {
    /**
     * 
     * @type {string}
     * @memberof LeiTestStatus
     */
    expiration?: string;
    /**
     * 
     * @type {string}
     * @memberof LeiTestStatus
     */
    status?: string;
}

/**
 * Check if a given object implements the LeiTestStatus interface.
 */
export function instanceOfLeiTestStatus(value: object): boolean {
    return true;
}

export function LeiTestStatusFromJSON(json: any): LeiTestStatus {
    return LeiTestStatusFromJSONTyped(json, false);
}

export function LeiTestStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeiTestStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'expiration': json['expiration'] == null ? undefined : json['expiration'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function LeiTestStatusToJSON(value?: LeiTestStatus | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'expiration': value['expiration'],
        'status': value['status'],
    };
}

